// It could be your App.tsx file or theme file that is included in your tsconfig.json
import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/styles/defaultTheme' {
    interface DefaultTheme extends Theme {}
}

const theme = createTheme({
    palette: {
        primary: {
            main: "#ffffff",
            contrastText: '#ffffff',
            /*Icon: {
                active: "#009fe3",
                inactive: "#808080",
                close: "#707070",
                closeHover: "#666666"
            }*/
        },
        secondary: {
            main: "#009fe3",
            /*Icon: {
                active: "#009fe3",
                inactive: "#d3d3d3",
                hover: "rgba(92, 206, 255, .25)",
                close: "rgba(123, 123, 123, .3)",
                closeHover: "rgba(123, 123, 123, .8)"
            }*/
        },
        /*Typography: {
            fontFamily: 'Roboto',
        },
        immersightButton: {
            main: "#009fe3",
            contrastText: '#ffffff'
        },
        immersightBlue: {
            main: "#009fe3",
        },
        immersightGrey: {
            main: "#9b9b9b",
        },
        deleteButton: {
            main: "red",
            contrastText: '#ffffff',
        },
        logout: {
            main: "#eeeeee",
            contrastText: "#000000"
        },
        input: {
            background: "#dedede",
            text: "#000000",
            backgroundHover: "#acacac"
        }*/
    }, typography: {
        fontFamily: [
            'Roboto',
            'Arial',
            'sans-serif'
        ].join(',')
    },
    components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              // when you hover and you are NOT focused
              '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#999',
              },
              // when you are focused
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#555',
                borderWidth: '1px',
              },
            },
          },
        },
        MuiInputLabel: {
            styleOverrides: {
              root: {
                // idle label colour
                color: 'rgba(0,0,0,0.6)',
      
                '&.Mui-focused': {
                  color: '#555',
                },
              },
            },
        },
      },

});

export default theme;